const selectors = {
  CHECKBOX_ACCEPT_MARKETING: '#customer_accepts_marketing',
  form: 'form',
  VALIDATE_FORM_SELECTOR: 'custom-validate-form'
}

const { publicKey, subscriptionUrl, listId } = window.klaviyoConfig

class AccountRegisterCustom extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector(selectors.form)
    this.validateForm = this.querySelector(selectors.VALIDATE_FORM_SELECTOR)
    this.checkboxAcceptMarketing = this.querySelector(selectors.CHECKBOX_ACCEPT_MARKETING)
  }

  connectedCallback() {
    this.validate = this.validateForm.initValidate(this.form, true)

    this.validate.onSuccess((event) => {
      event.preventDefault()

      if (this.checkboxAcceptMarketing.checked) {
        this.onSubmitForm()
      }
      // TODO: this can be removed if the back off fetch feature works
      const url = new URL(window.location.href)
      url.searchParams.set('register', 'complete')
      window.history.replaceState(null, '', url.toString());

      this.form.submit()
    })
  }

  async onSubmitForm() {
    const { email } = {
      email: Object.fromEntries(new FormData(this.form).entries())['customer[email]']
    }

    const url = `${subscriptionUrl}?company_id=${publicKey}`
    const options = {
      method: 'POST',
      headers: { revision: '2024-07-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }

    try {
      const response = await fetch(url, options)
    } catch (error) {
      console.log('The subscription marketing list was unsuccessful due to an error:', error)
    }
  }
}

if (!customElements.get('account-register-custom')) {
  customElements.define('account-register-custom', AccountRegisterCustom)
}
